/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2024, Zumper
 */

import { useAirbnbFriendly } from '@zcode-ui/filters'
import { PropertyFeatures } from '@zcode/enums'
import type { Listable, Pin, RawPinInventorySearch } from '@zcode/state-type'
import React, { type ReactElement, useMemo } from 'react'
import { ListCardBadge } from './ListCardBadge'
import { badgePropertyArray, badgeTitlesAndLabelsMap } from './constants'

interface ListCardBadgesType {
  entity: Listable | Pin<RawPinInventorySearch>
}

export const ListCardBadges = ({ entity }: ListCardBadgesType) => {
  const isAirbnbFriendly =
    useAirbnbFriendly() && !!entity?.features?.includes(PropertyFeatures.AIRBNB_FRIENDLY)
  const filteredBadgeArray = badgePropertyArray.filter((key) =>
    !isAirbnbFriendly ? key !== 'isAirbnbFriendly' : true
  )

  const badges = useMemo(() => {
    const badgeArr: ReactElement[] = []
    for (let i = 0; i < filteredBadgeArray.length && badgeArr.length < 2; i++) {
      const property = filteredBadgeArray[i]
      if (entity[property as keyof typeof entity]) {
        const [title, label] = badgeTitlesAndLabelsMap[property]

        badgeArr.push(<ListCardBadge key={title} label={label} title={title} />)
      }
    }
    return badgeArr
  }, [entity.groupId])

  return badges.length ? <>{badges}</> : null
}
